export function normalizeRequiredText(value: string | null | undefined): string {
  return String(value ?? '').trim();
}

export function normalizeOptionalText(value: string | null | undefined): string | null {
  const normalizedValue = normalizeRequiredText(value);
  return normalizedValue.length > 0 ? normalizedValue : null;
}
